import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import api from "@/api";
export default {
  props: {
    examPlanId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      paperDialogFormVisible: false,
      unitDialogFormVisible: false,
      form: {},
      paperList: [],
      unitForm: {}
    };
  },
  beforeMount() {
    this.getPaperList();
  },
  methods: {
    refreshTable() {
      this.$nextTick(() => {
        // 在数据加载完，重新渲染表格 如果不刷新会出现数据缓存
        this.$refs['table'].doLayout();
      });
    },
    async getPaperList() {
      const list = await api.getPaperList({
        examPlanId: this.examPlanId
      });
      this.paperList = list.map(item => {
        const list = item.units;
        const unit1 = list.filter(item => item.unitOrder === 1)[0];
        const unit2 = list.filter(item => item.unitOrder === 2)[0];
        const unit3 = list.filter(item => item.unitOrder === 3)[0];
        return {
          ...item,
          unit1: unit1 ? unit1.unitName + ' 模版ID：' + unit1.questionTplId + ' 时长：' + unit1.duration + ' 题目数：' + unit1.questionCount : '未配置',
          unit2: unit2 ? unit2.unitName + ' 模版ID：' + unit2.questionTplId + ' 时长：' + unit2.duration + ' 题目数：' + unit2.questionCount : '未配置',
          unit3: unit3 ? unit3.unitName + ' 模版ID：' + unit3.questionTplId + ' 时长：' + unit3.duration + ' 题目数：' + unit3.questionCount : '未配置'
        };
      });
    },
    async getUserGroupList() {
      const list = await api.getUserGroupList();
      this.groupList = list;
    },
    createPaper() {
      this.form = {};
      this.paperDialogFormVisible = true;
    },
    handelUnitEdit(row) {
      this.unitDialogFormVisible = true;
      this.unitForm = {
        paperId: row.id
      };
    },
    async createSaveUnit() {
      await api.addExamUnit(this.unitForm);
      this.unitDialogFormVisible = false;
      this.getPaperList();
      this.refreshTable();
    },
    async createSavePaper() {
      if (this.form.id) {
        await api.updatePaper({
          ...this.form,
          examPlanId: this.examPlanId
        });
      } else {
        await api.createPaper({
          ...this.form,
          examPlanId: this.examPlanId
        });
      }
      this.paperDialogFormVisible = false;
      this.getPaperList();
      this.refreshTable();
    },
    async handelDelete(row) {
      await api.deletePaper({
        id: row.id
      });
      this.getPaperList();
      this.refreshTable();
    },
    handelPaperEdit(row) {
      this.paperDialogFormVisible = true;
      this.form = row;
    }
  }
};